import React from "react";
import { Box, IconButton, Stack } from "@mui/material";
import FacebookIcon from '@mui/icons-material/FacebookOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import YoutubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';
import TiktokIcon from '../img_icons/tiktok.png';
import SoundCloudIcon from '../img_icons/soundcloud.png';

const MenuRedes = () => {
    return(
        <Box 
            position="fixed" // Fijo en la pantalla
            top="50%"        // Centrado verticalmente
            sx={{
                transform: 'translateY(-50%)', // Para centrar exactamente en la pantalla
                boxShadow: 0,
                bgcolor: 'transparent',
                backgroundImage: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                zIndex: 1000, // Asegura que el menú esté por encima de otros elementos
            }}
        >
            <Stack
                direction="column"
                justifyContent="right"
                position="relative"
                left="45%"
                spacing={1}
                useFlexGap
                sx={{
                    color: '#f9f9f9',
                }}
                >
                <IconButton
                    color="inherit"
                    href="https://www.facebook.com/calocho.usugha"
                    aria-label="Facebook"
                    sx={{ alignSelf: 'center' }}
                >
                    <FacebookIcon />
                </IconButton>

                {/*<IconButton
                    color="inherit"
                    href="https://x.com/CalochoUsugha"
                    aria-label="X"
                    sx={{ alignSelf: 'center' }}
                >
                    <TwitterIcon />
                </IconButton>*/}

                <IconButton
                    color="inherit"
                    href="https://www.linkedin.com/in/carlos-andres-usuga-jaramillo-2126371a2"
                    aria-label="LinkedIn"
                    sx={{ alignSelf: 'center' }}
                >
                    <LinkedInIcon />
                </IconButton>

                <IconButton
                    color="inherit"
                    href="https://www.youtube.com/@calochousugha?sub_confirmation=1"
                    aria-label="LinkedIn"
                    sx={{ alignSelf: 'center' }}
                >
                    <YoutubeIcon />
                </IconButton>

                <IconButton
                    color="inherit"
                    href="https://www.instagram.com/calocho_usugha"
                    aria-label="LinkedIn"
                    sx={{ alignSelf: 'center' }}
                >
                    <InstagramIcon />
                </IconButton>

                <IconButton
                    color="inherit"
                    href="https://co.pinterest.com/calocho_usugha"
                    aria-label="LinkedIn"
                    sx={{ alignSelf: 'center' }}
                >
                    <PinterestIcon />
                </IconButton>

                <IconButton
                    color="inherit"
                    href="https://www.tiktok.com/@calochousugha"
                    aria-label="LinkedIn"
                    sx={{ alignSelf: 'center' }}
                >
                     <img src={TiktokIcon} alt="TikTok" width="24" height="24" style={{ borderRadius: '50%', border: 'solid 1px #f9f9f9', padding: '1px' }} />
                </IconButton>

                <IconButton
                    color="inherit"
                    href="https://soundcloud.com/calocho-usugha"
                    aria-label="LinkedIn"
                    sx={{ alignSelf: 'center' }}
                >
                    <img src={SoundCloudIcon} alt="TikTok" width="24" height="24" style={{ borderRadius: '50%', border: 'solid 1px #f9f9f9', padding: '0.5px' }} />
                </IconButton>
            </Stack>
        </Box>
    );
}

export default MenuRedes;